import React from 'react'
import PropTypes from 'prop-types'

import CompanyFieldInput from './CompanyFieldInput'

export default class CompanyInfoInput extends React.Component {

  static propTypes = {
    disabled: PropTypes.bool,
    companyInfo: PropTypes.object.isRequired,
    companyInfoValidation: PropTypes.object,
    onCompanyInfoChanged: PropTypes.func.isRequired,
    onEnterPressed: PropTypes.func.isRequired
  }

  handleTextChanged = (field, value) => {
    this.props.onCompanyInfoChanged(
      Object.assign(this.props.companyInfo, { [field]: value })
    )
  }

  getValidationErrorText = field => {
    if (this.props.companyInfoValidation
      && this.props.companyInfoValidation.hasOwnProperty(field)) {
      return this.props.companyInfoValidation[field].message
    }
    return undefined
  }

  componentDidMount() {
    // Autofocus the full name field
    this.fullNameField.focus()
  }
  
  render() {
    return (
      <div style={styles.container}>
        <div style={styles.newCompanyText}>
          New
        </div>
        <div style={styles.newCompanyText}>
          Organization
        </div>
        <CompanyFieldInput
          id='fullName'
          ref={fullNameField => this.fullNameField = fullNameField}
          disabled={this.props.disabled}
          onTextChanged={value => this.handleTextChanged('fullName', value)}
          hintText='Full name' style={{ marginBottom: 18 }}
          errorText={this.getValidationErrorText('fullName')}
          onEnterPressed={this.props.onEnterPressed} />
        <CompanyFieldInput
          id='emmail'
          disabled={this.props.disabled}
          onTextChanged={value => this.handleTextChanged('email', value)}
          hintText='Email' style={{ marginBottom: 18 }}
          errorText={this.getValidationErrorText('email')}
          onEnterPressed={this.props.onEnterPressed} />
        <CompanyFieldInput
          id='companyName'
          disabled={this.props.disabled}
          onTextChanged={value => this.handleTextChanged('companyName', value)}
          hintText='Organization name' style={{ marginBottom: 18 }}
          errorText={this.getValidationErrorText('companyName')}
          onEnterPressed={this.props.onEnterPressed} />
        <CompanyFieldInput
          id='role'
          disabled={this.props.disabled}
          onTextChanged={value => this.handleTextChanged('role', value)}
          hintText='Your position' style={{ marginBottom: 18 }}
          errorText={this.getValidationErrorText('role')}
          onEnterPressed={this.props.onEnterPressed} />
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  newCompanyText: {
    width: 233,
    fontFamily: 'Roboto',
    fontSize: 36,
    lineHeight: 0.56,
    textAlign: 'center',
    color: '#4a4a4a',
    marginBottom: 20
  }

}



// WEBPACK FOOTER //
// ./src/login/CompanyInfoInput.js